import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { Typography } from '@/components/ui/typography'
import { formatPrice } from '@/utils/prices'
import numeral from 'numeral'
import { useTopGainers } from '@/hooks/use-top-gainers'
import { Skeleton } from '@/components/ui/skeleton'
import { v4 as uuidv4 } from 'uuid'
import { formatAmount } from '@/utils/format'

export const Tokens = () => {
  const { gainers, isLoading } = useTopGainers()

  return (
    <div className={'border rounded-xl'}>
      <Table>
        <TableHeader className={'rounded-2xl text-xs font-bold'}>
          <TableRow>
            <TableHead>Asset</TableHead>
            <TableHead>Price</TableHead>
            <TableHead>1D</TableHead>
            <TableHead>Martet Cap</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {isLoading ? (
            <>
              {[...Array(5)].map(() => (
                <TableRow key={uuidv4()}>
                  <TableCell>
                    <div className="flex items-center gap-2">
                      <Skeleton className="h-7 w-7 rounded-full" />
                      <div>
                        <Skeleton className="h-4 w-16" />
                        <Skeleton className="h-3 w-24 mt-1" />
                      </div>
                    </div>
                  </TableCell>
                  <TableCell>
                    <Skeleton className="h-4 w-20" />
                  </TableCell>
                  <TableCell>
                    <Skeleton className="h-4 w-12" />
                  </TableCell>
                  <TableCell>
                    <Skeleton className="h-4 w-24" />
                  </TableCell>
                </TableRow>
              ))}
            </>
          ) : (
            gainers?.map((token) => (
              <TableRow key={token.symbol}>
                <TableCell>
                  <div className="flex items-center gap-2">
                    <img src={token.logoURI} alt={'logo'} width={28} height={28} className="rounded-full" />
                    <div>
                      <Typography>{token.symbol}</Typography>
                      <Typography variant={'tip'}>{token.name}</Typography>
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  <Typography>${formatPrice(token.currentPrice)}</Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    variant={'small'}
                    className={token.priceChange24h >= 0 ? 'text-green-500' : 'text-red-500'}
                  >
                    {token.priceChange24h}%
                  </Typography>
                </TableCell>
                <TableCell>${numeral(Number(token.marketCap).toFixed(0)).format('0,0')}</TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  )
}
